import { FaAngleDoubleUp } from 'react-icons/fa';
import { animateScroll as scroll } from 'react-scroll'
import React, { useState } from 'react';
import './Footer.css';
const Footer = () => {
    const [showScroll, setShowScroll] = useState(false)

    const checkScrollTop = () => {
        if (!showScroll && window.pageYOffset > 400) {
            setShowScroll(true)
        }
        else if (showScroll && window.pageYOffset <= 400) {
            setShowScroll(false)
        }
    };
    const scrollTop = () => {
        window.scrollTo({ top: 0});
    };

    window.addEventListener('scroll', checkScrollTop)

    return (
        <footer>
            <FaAngleDoubleUp
                className="scrollTop"
                onClick={() => scroll.scrollToTop() || scrollTop()}
                style={{ height: 40, display: showScroll ? 'block' : 'none' }}
                offset={100}
                duration={1000} 
                delay={100}
            />
            <div className="footer-desc">
                <p className="text-center p-3"> &copy; Ujjal zaman All Rights & Reserved {(new Date().getFullYear())}</p>

            </div>
        </footer>
    );
};

export default Footer;